function cuzSuccess(selector) {
	let datapop = {};

	datapop.body = $('body');
	datapop.container = $(selector);

	datapop.closer = datapop.container.find('[data-trade="closer"]');
	
	datapop.show = function () {
		datapop.body.css({ 'overflow-y': 'hidden' });
		datapop.container.addClass('is--active');
	}
	
	datapop.hide = function () {
		datapop.container.removeClass('is--active');
		datapop.body.css({ 'overflow-y': 'auto' });
	}

	datapop.closer.on('click', datapop.hide);

	return datapop;
}